import { AdditonalInfoBody } from '@src/app/core/models/ib-checkin-apis/services/additional-info-model';
import { IPromise } from 'angular';
@Service('ib-http-services-module', [
    '$q',
    'CommonsGenericProxy',
    'CommonsHttpUtilsErrorService',
    'HttpServicesConstants',
    'localStorageService',
    '$filter',
    'UtilsService'
])
export class PassengerAdditionalInfoService {
    private counterAttemps = 0;

    constructor (
        private $q: ng.IQService,
        private CommonsGenericProxy: CommonsGenericProxy,
        private CommonsHttpUtilsErrorService: CommonsHttpUtilsErrorService,
        private HttpServicesConstants: HttpServicesConstantsNamespace.HttpServicesConstants,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private $filter: angular.IFilterService,
        private UtilsService
    ) {}

    updateAdditionalInfo = (additionalInfo) => {
        let defer = this.$q.defer();
        const updateAdditionalInfoSuccess = (data): void => {
            defer.resolve(data.data);
            defer = null;
            this.counterAttemps = 0;
        };
        const checkinIdError = (): void => {
            defer.reject({ errorCode: 'IB_00002', message: this.$filter('translate')('SESSION_EXPIRED'), internalErrorCode: 'IB_00002' });
            defer = null;
            this.counterAttemps = 0;
        };
        const updateAdditionalInfoCallback = (): void => {
            this.counterAttemps++;
            this.updateAdditionalInfo(additionalInfo);
        };
        const updateAdditionalInfoError = (err: any) => {
            this.CommonsHttpUtilsErrorService.controlError(err, this.counterAttemps, updateAdditionalInfoCallback, defer);
        };
        const checkinId = this.localStorageService.get('flowId') || checkinIdError();
        const endpoint = this.HttpServicesConstants.URI.DEFAULT_ENDPOINTS.passengerAdditionalInfoURI + checkinId + '/additional-info';
        this.CommonsGenericProxy.putGeneric(endpoint, additionalInfo).then(updateAdditionalInfoSuccess, updateAdditionalInfoError);
        return defer.promise;
    };

    updateEmergencyInfo = (emergencyInfo) => {
        let defer = this.$q.defer();
        const updateEmergencyInfoSuccess = (data): void => {
            defer.resolve(data.data);
            defer = null;
            this.counterAttemps = 0;
        };
        const checkinIdError = (): void => {
            defer.reject({ errorCode: 'IB_00002', message: this.$filter('translate')('SESSION_EXPIRED'), internalErrorCode: 'IB_00002' });
            defer = null;
            this.counterAttemps = 0;
        };
        const updateEmergencyInfoCallback = (): void => {
            this.counterAttemps++;
            this.updateEmergencyInfo(emergencyInfo);
        };
        const checkinId = this.localStorageService.get('flowId') || checkinIdError();
        const endpoint = this.HttpServicesConstants.URI.DEFAULT_ENDPOINTS.passengerAdditionalInfoURI + checkinId + '/emergency';
        this.CommonsGenericProxy.putGeneric(endpoint, emergencyInfo).then(updateEmergencyInfoSuccess, (err: any) =>
            this.CommonsHttpUtilsErrorService.controlError(err, this.counterAttemps, updateEmergencyInfoCallback, defer)
        );
        return defer.promise;
    };

    getAdditionalInfo = (passengersId): IPromise<AdditonalInfoBody> => {
        let defer = this.$q.defer();
        const getAdditionalInfoSuccess = (data): void => {
            defer.resolve(data.data);
            defer = null;
            this.counterAttemps = 0;
        };
        const checkinIdError = (): void => {
            defer.reject({ errorCode: 'IB_00002', message: this.$filter('translate')('SESSION_EXPIRED'), internalErrorCode: 'IB_00002' });
            defer = null;
            this.counterAttemps = 0;
        };
        const getAdditionalInfoCallback = (): void => {
            this.counterAttemps++;
            this.getAdditionalInfo(passengersId);
        };
        const checkinId = this.localStorageService.get('flowId') || checkinIdError();
        if (passengersId && passengersId.length > 0) {
            const endpoint = this.HttpServicesConstants.URI.DEFAULT_ENDPOINTS.passengerAdditionalInfoURI + checkinId + '/additional-info' + this.UtilsService.generatePassengersQueryString(passengersId);
            this.CommonsGenericProxy.getGeneric(endpoint).then(getAdditionalInfoSuccess, (err: any) =>
                this.CommonsHttpUtilsErrorService.controlError(err, this.counterAttemps, getAdditionalInfoCallback, defer)
            );
        } else {
            getAdditionalInfoSuccess([]);
        }
        return defer.promise as IPromise<AdditonalInfoBody>;
    };
    getEmergencyInfo = (passengersId) => {
        let defer = this.$q.defer();
        const getEmergencyInfoSuccess = (data): void => {
            defer.resolve(data.data);
            defer = null;
            this.counterAttemps = 0;
        };
        const checkinIdError = (): void => {
            defer.reject({ errorCode: 'IB_00002', message: this.$filter('translate')('SESSION_EXPIRED'), internalErrorCode: 'IB_00002' });
            defer = null;
            this.counterAttemps = 0;
        };
        const getEmergencyInfoCallback = (): void => {
            this.counterAttemps++;
            this.getEmergencyInfo(passengersId);
        };
        const checkinId = this.localStorageService.get('flowId') || checkinIdError();
        if (passengersId && passengersId.length > 0) {
            const endpoint = this.HttpServicesConstants.URI.DEFAULT_ENDPOINTS.passengerAdditionalInfoURI + checkinId + '/emergency' + this.UtilsService.generatePassengersQueryString(passengersId);
            this.CommonsGenericProxy.getGeneric(endpoint).then(getEmergencyInfoSuccess, (err: any) =>
                this.CommonsHttpUtilsErrorService.controlError(err, this.counterAttemps, getEmergencyInfoCallback, defer)
            );
        } else {
            getEmergencyInfoSuccess([]);
        }
        return defer.promise;
    };
}
